var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-full",staticStyle:{"color":"var(--primary)","padding":"5px"}},[_vm._v(" "+_vm._s(_vm.config ? _vm.config.text : '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }